module.exports = {
  "APP_NAME": "EXO",
  "APP_DISPLAY_NAME": "EXO",
  "FONT_NAME": "InterVariable",
  "STORE_VERSION": 1,
  "LIB_NAME": "react-exo",
  "LIB_VERSION": "1.0.0",
  "LINK_DOCS": "https://exo.ult.dev",
  "LINK_STORYBOOK": "https://exo.fig.run",
  "LINK_DISCORD": "https://discord.gg/KpMZVKmfnb",
  "LINK_GITHUB": "https://github.com/kat-tax/exo",
  "LINK_X": "https://x.com/theultdev",
  "PACKAGE_IOS": "com.exo.ios",
  "PACKAGE_MACOS": "com.exo.macos",
  "PACKAGE_ANDROID": "com.exo.android",
  "PACKAGE_WINDOWS": "com.exo.windows",
  "SYNC_HOST": "https://evolu.world",
  "REACT_SCAN_URL": "https://monitoring.react-scan.com/api/v1/ingest",
  "REACT_SCAN_API_KEY": "5SE0ZR4SUqaR01juRSCMI2HQDB_4lqfO"
}
